import Menu from 'src/models/menu';
import start from 'src/assets/start.svg';
import reports from 'src/assets/reports.svg';
import users from 'src/assets/users.svg';
import academic from 'src/assets/academic.svg';
import MenuTag from 'src/models/menu-tag';
import { FaSuitcase, FaUsers } from 'react-icons/fa';

const menus: Menu[] = [
  { icon: <img src={start} alt="home" />, title: 'Início', url: '/home' },
  {
    icon: <FaUsers />,
    title: 'Parceiros',
    url: '/customization/partners',
    tag: MenuTag.customization,
  },
  {
    icon: <img src={academic} alt="academic" />,
    title: 'Acadêmico',
    url: '/customization/academic',
    tag: MenuTag.customization,
    children: [
      { title: 'Especialidades', url: '/customization/academic/specialties' },
      { title: 'Temas', url: '/customization/academic/themes' },
      { title: 'Conteúdos', url: '/customization/academic/contents' },
      { title: 'Autores', url: '/customization/academic/authors' },
      { title: 'Tags', url: '/customization/academic/tags' },
    ],
  },
  {
    icon: <FaSuitcase />,
    title: 'Planos',
    url: '/customization/plans',
    tag: MenuTag.customization,
  },
  // {
  //   icon: <img src={exam} alt="exam" />,
  //   title: 'Avaliação',
  //   url: '/customization/exam',
  //   tag: MenuTag.customization,
  // },
  // {
  //   icon: <img src={faqs} alt="faqs" />,
  //   title: 'FAQs',
  //   url: '/customization/faqs',
  //   tag: MenuTag.customization,
  // },
  // {
  //   icon: <img src={forum} alt="forum" />,
  //   title: 'Fórum',
  //   url: '/customization/forum',
  //   tag: MenuTag.customization,
  // },
  // {
  //   icon: <img src={institutional} alt="institutional" />,
  //   title: 'Institucional',
  //   url: '/customization/institutional',
  //   tag: MenuTag.customization,
  // },
  {
    icon: <img src={reports} alt="reports" />,
    title: 'Relatórios',
    url: '/others/reports',
    tag: MenuTag.others,
    children: [
      { title: 'Engajamento', url: '/others/reports/engagement' },
      {
        title: 'Conteúdos concluídos',
        url: '/others/reports/contents-finished',
      },
    ],
  },
  {
    icon: <img src={reports} alt="statistics" />,
    title: 'Estatísticas',
    url: '/others/statistics',
    tag: MenuTag.others,
    children: [
      {
        title: 'Contéudos',
        url: '/others/statistics/contents',
      },
      {
        title: 'Autores',
        url: '/others/statistics/authors',
      },
      {
        title: 'Especialidades',
        url: '/others/statistics/specialties',
      },
      {
        title: 'Temas',
        url: '/others/statistics/themes',
      },
      {
        title: 'Tags',
        url: '/others/statistics/tags',
      },
    ],
  },
  {
    icon: <img src={users} alt="users" />,
    title: 'Usuários',
    url: '/users',
    tag: MenuTag.others,
  },
];

export default menus;
